import { render, staticRenderFns } from "./MyFamily.vue?vue&type=template&id=70900a2a&scoped=true&"
import script from "./MyFamily.vue?vue&type=script&lang=js&"
export * from "./MyFamily.vue?vue&type=script&lang=js&"
import style0 from "./MyFamily.vue?vue&type=style&index=0&id=70900a2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70900a2a",
  null
  
)

export default component.exports